import type { FC, ReactElement } from "react"

import capitalize from "lodash-es/capitalize"

import { buildCssClassName } from "@/3514/utils"
import { type IUseTranslation, useTranslation } from "@/hooks"

import type { TEmailBannerConfig } from "./types"

type TProps = TEmailBannerConfig

const EmailBanner: FC<TProps> = ({ isVisible, productType }: TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <div className={buildCssClassName("coach-welcome__email-banner", { "d-none": !isVisible })}>
            <p className="font-extrabold mr-1 mb-0 font-sm">{t("coachSide.welcomePage.emailBanner.question")}</p>
            <p className="ml-1 mb-0 font-sm">
                {t("coachSide.welcomePage.emailBanner.description", {
                    cohortProductType: productType ? capitalize(productType) : String()
                })}
            </p>
        </div>
    )
}

export { EmailBanner as CoachWelcomeEmailBanner, type TProps as TCoachWelcomeEmailBannerProps }
